import React from "react";
import { Route } from "react-router-dom";
import ListAnimalsContainer from "./list-container";
import AddAnimal from "./add";
import EditAnimal from "./edit";
import SetAnimalScenes from "./scenes";
import Menu from "./menu";
import { PrivateRoute } from "../../../shared/private-route";

const AnimalRoutes = () => {
  return (
    <>
      <PrivateRoute
        path="/films/:filmId/animals"
        component={ListAnimalsContainer}
      />
      <PrivateRoute
        path="/films/:filmId/animals/:setDressingId"
        component={Menu}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/animals/add"
        component={AddAnimal}
      />

      <PrivateRoute
        exact
        path="/films/:filmId/animals/:setDressingId"
        component={EditAnimal}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/animals/:setDressingId/edit"
        component={EditAnimal}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/animals/:setDressingId/scenes"
        component={SetAnimalScenes}
      />
    </>
  );
};

export default AnimalRoutes;
